<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>

    
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab @click="showNewApplications=true;showResolvedApplications=false">
          Pending
          <v-chip color="primary" class="white--text">{{pendingTotalItems}}</v-chip>
        </v-tab>
        <v-tab @click="showNewApplications=false;showResolvedApplications=true">
          Completed
          <v-chip color="success" class="white--text">{{resolvedTotalItems}}</v-chip>
        </v-tab>
        <!-- <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>-->
      </v-tabs>
    </v-toolbar>
    <v-toolbar flat color="white">
      <!-- <v-btn color="primary" dark class="mb-2" @click="newDialog=true" round>ADD APPLICANT</v-btn> -->
      <v-spacer></v-spacer>
      <v-text-field
      v-if="showNewApplications"
        v-model="pendingSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          pendingOffset: $route.query.pendingOffset,
          resolvedOffset: $route.query.resolvedOffset,
          pendingSearch: pendingSearch,
          resolvedSearch: $route.query.resolvedSearch,
          records: $route.query.records
          }})"
      ></v-text-field>
      <v-text-field
      v-if="showResolvedApplications"
        v-model="resolvedSearch"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
        v-on:keyup.enter="$router.push({name: $route.name, 
        query:{
          pendingOffset: $route.query.pendingOffset,
          resolvedOffset: $route.query.resolvedOffset,
          pendingSearch: $route.query.pendingSearch,
          resolvedSearch: resolvedSearch,
          records: $route.query.records
          }})"
      ></v-text-field>
    </v-toolbar>

    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-flex v-if="showNewApplications">
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="[$route.query.records]"
      :loading="isLoading"
      :items="newApplications"
      item-key="id"
      disable-initial-sort
      align-center
      style="cursor: pointer"
      hide-actions
    >
      <template v-slot:items="props">
         <td class="text-xs-center" @click="routerLinkToDetails(props.item)"> <v-chip
          v-if="props.item.type=='Order'" small class="white--text" color="light-green">Order</v-chip>
          <v-chip v-else-if="props.item.type=='Lead'" small class="white--text" color="blue">Lead</v-chip>
          <v-chip v-else-if="props.item.type=='Qualified'" small class="white--text" color="orange">Qualified</v-chip>
          <v-chip v-else-if="props.item.type=='Proposal'" small class="white--text" color="purple">Proposal</v-chip>
          </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)">{{props.item.id}}</td>
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{formatDate(props.item.createdAt)}}</td>
        

        <td v-if="props.item.locationId"
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.location.locationDescription}}</td><td v-else
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        ></td>
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.supplierOrganisation.name}}</td>
        <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.invoiceNumber!==null">
        {{props.item.invoiceNumber}}
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.invoiceNumber!==null">
        <v-icon v-if="props.item.isPaid" color="green">done</v-icon>
        <v-icon v-if="!props.item.isPaid" color="red">not_interested</v-icon>
        </td>-->
        <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        
        </td>-->
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
          v-if="props.item.packagesIspId&&props.item.ispVerified&&props.item.ispAccepted"
        >
          <v-chip color="success" class="white--text">Accepted</v-chip>
        </td>
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
          v-else-if="props.item.packagesIspId&&props.item.ispVerified&&!props.item.ispAccepted"
        >
          <v-chip color="red" class="white--text">Rejected</v-chip>
        </td>
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
          v-else-if="props.item.packagesIspId"
        >
          <v-chip color="warning" class="white--text">Pending</v-chip>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
          <v-chip color="grey" class="white--text">N/A</v-chip>
        </td>
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
          v-if="props.item.isInstallVerified"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>

        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
          v-if="props.item.isDeviceVerified"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>

        <!-- <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-if="props.item.isPackageVerified">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>-->

        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
          v-if="props.item.isContactVerified"
        >
          <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
          <v-icon color="red">not_interested</v-icon>
        </td>
        <td
          class="text-xs-center"
          v-if="props.item.primaryContactTitle!==null"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.primaryContactTitle + ' '+props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>
        <td
          class="text-xs-center"
          v-else
          @click="routerLinkToDetails(props.item)"
        >{{props.item.primaryContactFirstname+ ' '+props.item.primaryContactLastname}}</td>

        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.primaryContactMobileNumber}}</td>
        <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.primaryContactEmailAddress}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
    <div class="text-xs-center pt-2 white" :key="$route.query.pendingOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="pendingPage"
              :length="Math.ceil(pendingTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
      </v-flex>
    <v-flex v-if="showResolvedApplications">
      <v-data-table
        :headers="resolvedHeaders"
        class="elevation-1"
        :rows-per-page-items="[$route.query.records]"
        :loading="isLoading"
        :items="resolvedApplications"
        item-key="id"
        disable-initial-sort
        align-center
        style="cursor: pointer"
        hide-actions
      >
        <template v-slot:items="props">
           <td class="text-xs-center" @click="routerLinkToDetails(props.item)"> <v-chip
          v-if="props.item.type=='Order'" small class="white--text" color="light-green">Order</v-chip>
          <v-chip v-else-if="props.item.type=='Lead'" small class="white--text" color="blue">Lead</v-chip>
          <v-chip v-else-if="props.item.type=='Qualified'" small class="white--text" color="orange">Qualified</v-chip>
          <v-chip v-else-if="props.item.type=='Proposal'" small class="white--text" color="purple">Proposal</v-chip>
          </td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.id}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.location.locationDescription}}</td>
          <td
          class="text-xs-center"
          @click="routerLinkToDetails(props.item)"
        >{{props.item.supplierOrganisation.name}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.isApproved"
          >
            <v-chip class="green white--text">Approved</v-chip>
          </td>
          <td class="text-xs-center" @click="routerLinkToDetails(props.item)" v-else>
            <v-chip class="red white--text">Denied</v-chip>
          </td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{formatDate(props.item.createdAt)}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{formatDate(props.item.resolvedDate)}}</td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
            v-if="props.item.resolvedById"
          >{{props.item.resolvedBy.name}} {{props.item.resolvedBy.surname}}</td>
          <td v-else></td>
          <td
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.deniedReason}}</td>
          <td
            v-if="props.item.primaryContactId!==null"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.primaryContact.name}} {{props.item.primaryContact.surname}}</td>
          <td class="text-xs-center" v-else></td>
          <td
            v-if="props.item.primaryContactId!==null"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.primaryContact.mobileNumber}}</td>
          <td class="text-xs-center" v-else></td>
          <td
            v-if="props.item.primaryContactId!==null"
            class="text-xs-center"
            @click="routerLinkToDetails(props.item)"
          >{{props.item.primaryContact.emailAddress}}</td>
          <td class="text-xs-center" v-else></td>
          <!-- <td v-if="props.item.primaryContactId!==null" class="text-xs-center" @click="routerLinkToDetails(props.item)">
        {{props.item.primaryContact.idNumber}}
        </td>
          <td class="text-xs-center" v-else></td>-->
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
      <div class="text-xs-center pt-2 white" :key="$route.query.resolvedOffset">
        <v-layout wrap>
          <v-flex xs12>
            <v-pagination
              v-model="resolvedPage"
              :length="Math.ceil(resolvedTotalItems/$route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data() {
    return {
      showDetails: true,
      showNewApplications: true,
      showResolvedApplications: false,
      isLoading: false,
      expand: false,
      search: "",
      dialog: false,
      snackbar: false,
      pendingPage: 1,
      pendingPagination: {},
      pendingSearch: "",
      pendingTotalItems: 0,
      resolvedPage: 1,
      resolvedPagination: {},
      resolvedSearch: "",
      resolvedTotalItems: 0,
      text: "",
      y: "top",
      allVlans: [],
      newApplications: [],
      newDialog: false,
      // resolvedPagination: {
      //   descending: true,
      //   activeTabName: "",
      //   sortBy: "resolvedDate"
      // },
      pagination: {
        descending: true,
        activeTabName: "",
        sortBy: "createdAt"
      },
      tabs: [
        { name: "newApplications", displayName: "Pending" },
        { name: "resolvedApplications", displayName: "Resolved" }
      ],
      resolvedHeaders: [
         {
          text: "Type",
          align: "center",
          value: "type"
        },
        {
          text: "Application ID:",
          align: "center",
          value: "id"
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Network Operator",
          align: "center",
          value: "supplierOrganisation.name"
        },
        {
          text: "Status",
          align: "center",
          sortable: false
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        {
          text: "Resolved Date",
          align: "center",
          value: "resolvedDate"
        },
        {
          text: "Resolved By",
          align: "center",
          value: "resolvedBy"
        },
        {
          text: "Comment",
          align: "center",
          value: "deniedReason"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        }
      ],
      headers: [
         {
          text: "Type",
          align: "center",
          value: "type"
        },
        {
          text: "Application ID:",
          align: "center",
          value: "id"
        },
        {
          text: "Submitted",
          align: "center",
          value: "createdAt"
        },
        
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Network Operator",
          align: "center",
          value: "supplierOrganisation.name"
        },
        // {
        //   text: "Invoice",
        //   align: "center",
        //   value: "invoiceNumber"
        // },
        // {
        //   text: "Invoice Paid",
        //   align: "center",
        //   value: "isPaid"
        // },
        {
          text: "ISP Acceptance",
          align: "center",
          value: "ispVerified"
        },
        {
          text: "Install Verified",
          align: "center",
          value: "isInstallVerified"
        },
        {
          text: "Device Verified",
          align: "center",
          value: "isDeviceVerified"
        },
        {
          text: "Contact Verified",
          align: "center",
          value: "isContactVerified"
        },
        {
          text: "Contact Name",
          align: "center",
          value: "primaryContactName"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "primaryContactMobileNumber"
        },
        {
          text: "Email Address",
          align: "center",
          value: "primaryContactEmailAddress"
        }
        // {
        //   text: "ID Number",
        //   align: "center",
        //   value: "primaryContactIdNumber"
        // }
      ],
      totalApplications: 0,
      applications: [],
      
    };
  },

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    // Pending Applications
    '$route.query.pendingSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.pendingSearch&&value!==""&&value != null){
        this.pendingPage = 1
        Api()
        .get('/applications/owner/active',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.pendingOffset){
             Api()
        .get('/applications/owner/active',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.pendingOffset': {
       immediate: true,
      handler(value){
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.pendingSearch&&this.$route.query.pendingSearch!="" &&this.$route.query.pendingSearch!== null){      
        
        Api()
        .get('/applications/owner/active',{
          params: {
          search: this.$route.query.pendingSearch,
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/applications/owner/active',{
          params: {
          offset: this.$route.query.pendingOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.newApplications=response.data.result
          this.pendingTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     pendingPage(value) {
      this.pendingPagination.page = this.pendingPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.pendingSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: this.$route.query.resolvedOffset,
              pendingOffset: (value - 1) * this.$route.query.records,
              resolvedSearch: this.$route.query.activeSearch
            }
          });
        }
      }
    },

    // Resolved
    '$route.query.resolvedSearch':{
      immediate: true,
      handler(value){
        this.isLoading=true
      if(this.$route.query.resolvedSearch&&value!==""&&value != null){
        this.resolvedPage = 1
        Api()
        .get('/applications/owner/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.isLoading=false
          })} else if(this.$route.query.resolvedOffset){
             Api()
        .get('/applications/owner/resolved',{
          params: {
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.isLoading=false})
          }
      }
    },
    '$route.query.resolvedOffset': {
       immediate: true,
      handler(value){
        console.log(value)
        this.isLoading=true
      if(value!==""&&value != null&&this.$route.query.resolvedSearch&&this.$route.query.resolvedSearch!="" &&this.$route.query.resolvedSearch!== null){      
        
        Api()
        .get('/applications/owner/resolved',{
          params: {
          search: this.$route.query.resolvedSearch,
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.isLoading=false})
      } else if(value != null){
         Api()
        .get('/applications/owner/resolved',{
          params: {
          offset: this.$route.query.resolvedOffset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.resolvedApplications=response.data.result
          this.resolvedTotalItems=response.data.count
            this.isLoading=false})
      }
    }},
     resolvedPage(value) {
       
      this.resolvedPagination.page = this.resolvedPage;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.resolvedSearch) {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              resolvedSearch: this.$route.query.resolvedSearch,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              records: this.$route.query.records,
              resolvedOffset: (value - 1) * this.$route.query.records,
              pendingOffset: this.$route.query.pendingOffset,
              pendingSearch: this.$route.query.pendingSearch
            }
          });
        }
      }
    },
  },

  async created() {
        this.$router.push({
      name: this.$route.name,
      query: {
        pendingOffset: "0",
        resolvedOffset: "0",
        records: "15"
      }
    })
  },

  methods: {
    async routerLinkToDetails(item) {
      if(item.type=='Order'){
      let url = item;
      let route = await this.$store.state.currentOrg.org.permissions.filter(
        function(el) {
          return el.url === "/virtualOwnerApplication/:applicationId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/virtualOwnerApplication/" + this.editedItem.id });
      }else{
     let route = await this.$store.state.currentOrg.org.permissions.filter(
        function(el) {
          return el.url === "/applications/lead/:applicationId";
        }
      );
      await this.$store.dispatch("setCurrentRoute", route[0]);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/applications/lead/" + this.editedItem.id });
      }
     
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    initialize() {
      this.setActiveTabName("newApplications");
    },
  }
};
</script>
